import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Blog2 = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">Blog Standard</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>Blog Standard</li>
          </ul>
        </div>
      </section>

      <div className="ul-section-spacing">
        <div className="ul-container">
          <div className="row ul-bs-row gy-5 flex-column-reverse flex-md-row">

            <div className="col-lg-4 col-md-5">
              <div className="ul-inner-sidebar">

                <div className="ul-inner-sidebar-widget ul-inner-sidebar-search">
                  <h3 className="ul-inner-sidebar-widget-title">Search</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <form action="#" className="ul-blog-search-form">
                      <input
                        type="search"
                        name="blog-search"
                        id="ul-blog-search"
                        placeholder="Search Here"
                      />
                      <button type="submit">
                        <span className="icon"
                          ><i className="flaticon-search"></i
                        ></span>
                      </button>
                    </form>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget categories">
                  <h3 className="ul-inner-sidebar-widget-title">Categories</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-categories">
                      <Link to="/donations">Charity <span>(08)</span></Link>
                      <Link to="/donations"
                        >Crowdfunding <span>(11)</span></Link
                      >
                      <Link to="/donations">Industries <span>(18)</span></Link>
                      <Link to="/donations">Innovations <span>(11)</span></Link>
                      <Link to="/donations">Technology <span>(07)</span></Link>
                    </div>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget posts">
                  <h3 className="ul-inner-sidebar-widget-title">Recent Posts</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-posts">

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/group-of-happy-volunteers-sorting-donations-while-2024-12-13-21-32-21-utc.jpg"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/food-distribution-volunteers-help-needy-2025-02-19-10-27-15-utc.jpg"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>

                      <div className="ul-inner-sidebar-post">
                        <div className="img">
                          <img
                            src="/assets/new-img/new/group-of-volunteers-sorting-garbage-2025-04-02-09-20-13-utc.JPG"
                            alt="Post Image"
                          />
                        </div>

                        <div className="txt">
                          <h4 className="title">
                            <Link to="/donations"
                              >Understanding Diabetes: A Bilingual Guide</Link
                            >
                          </h4>
                          <span className="date"> <span>May 12, 2025</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="ul-inner-sidebar-widget tags">
                  <h3 className="ul-inner-sidebar-widget-title">Tag Cloud</h3>
                  <div className="ul-inner-sidebar-widget-content">
                    <div className="ul-inner-sidebar-tags">
                      <Link to="/donations">Crowdfunding</Link>
                      <Link to="/donations">Innovations</Link>
                      <Link to="/donations">Justice</Link>
                      <Link to="/donations">Lead</Link>
                      <Link to="/donations">Startup</Link>
                      <Link to="/donations">Technology</Link>
                      <Link to="/donations">Market</Link>
                      <Link to="/donations">Court</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-7">

              <div>

                <div className="ul-blog ul-blog-2 ul-blog-inner">
                  <div className="ul-blog-img">
                    <img
                      src="/assets/new-img/new/group-of-happy-volunteers-sorting-donations-while-2024-12-13-21-32-21-utc.jpg"
                      alt="Blog Image"
                    />
                  </div>
                  <div className="ul-blog-txt">
                    <div className="ul-blog-infos">

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-account"></i
                        ></span>
                        <span className="text">By Admin</span>
                      </div>

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-price-tag"></i
                        ></span>
                        <span className="text">Donation</span>
                      </div>
                    </div>
                    <Link to="/donations" className="ul-blog-title"
                      >Outstanding entrepreneurs and develop your skills.</Link
                    >
                    <p className="ul-blog-excerpt">
                      When to Use Lorem Ipsum generally, lorem ipsum is best
                      suited to keeping template fo looking bare or minimizing
                      the distractions of the draft copy. Second, use lorem
                      ipsum if you think placeholder text will distracting. in
                      voluptate velit esse. Cursus libero viverra.
                    </p>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Read More</Link
                    >
                  </div>
                </div>

                <div className="ul-blog ul-blog-2 ul-blog-inner">
                  <div className="ul-blog-img">
                    <img
                      src="/assets/new-img/new/food-distribution-volunteers-help-needy-2025-02-19-10-27-15-utc.jpg"
                      alt="Blog Image"
                    />
                  </div>
                  <div className="ul-blog-txt">
                    <div className="ul-blog-infos">

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-account"></i
                        ></span>
                        <span className="text">By Admin</span>
                      </div>

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-price-tag"></i
                        ></span>
                        <span className="text">Donation</span>
                      </div>
                    </div>
                    <Link to="/donations" className="ul-blog-title"
                      >Best outstanding and develop your personal skills.</Link
                    >
                    <p className="ul-blog-excerpt">
                      When to Use Lorem Ipsum generally, lorem ipsum is best
                      suited to keeping template fo looking bare or minimizing
                      the distractions of the draft copy. Second, use lorem
                      ipsum if you think placeholder text will distracting. in
                      voluptate velit esse. Cursus libero viverra.
                    </p>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Read More</Link
                    >
                  </div>
                </div>

                <div className="ul-blog ul-blog-2 ul-blog-inner">
                  <div className="ul-blog-img">
                    <img
                      src="/assets/new-img/new/people-donating-clothing-to-charity-collection-in-2024-10-21-08-45-33-utc.jpg"
                      alt="Blog Image"
                    />
                  </div>
                  <div className="ul-blog-txt">
                    <div className="ul-blog-infos">

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-account"></i
                        ></span>
                        <span className="text">By Admin</span>
                      </div>

                      <div className="ul-blog-info">
                        <span className="icon"
                          ><i className="flaticon-price-tag"></i
                        ></span>
                        <span className="text">Donation</span>
                      </div>
                    </div>
                    <Link to="/donations" className="ul-blog-title"
                      >Money markets rates finding the best account</Link
                    >
                    <p className="ul-blog-excerpt">
                      When to Use Lorem Ipsum generally, lorem ipsum is best
                      suited to keeping template fo looking bare or minimizing
                      the distractions of the draft copy. Second, use lorem
                      ipsum if you think placeholder text will distracting. in
                      voluptate velit esse. Cursus libero viverra.
                    </p>
                    <Link to="/donations" className="ul-btn"
                      ><i
                        className="flaticon-fast-forward-double-right-arrows-symbol"
                      ></i>
                      Read More</Link
                    >
                  </div>
                </div>
              </div>

              <div className="ul-pagination">
                <ul>
                  <li>
                    <button type="button" className="pagination-prev" aria-label="Previous"><i className="flaticon-back"></i></button>
                  </li>
                  <li className="pages" role="navigation" aria-label="Pagination">
                    <button type="button" className="active">1</button>
                    <button type="button">2</button>
                    <button type="button">3</button>
                  </li>
                  <li>
                    <button type="button" className="pagination-next" aria-label="Next"><i className="flaticon-next"></i></button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

      <Footer />
    </>
  );
};

export default Blog2;
